import React from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { DataGrid, useGridApiRef, GridApiRef } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "./CustomNoRowsOverlay"
import PropTypes from "prop-types";

import { isDebug } from "../../utils";

export default function ControlDataGrid (props)
{
    const {t, dataType, manageId, boardColumns, dataSet, paginationModel, setPaginationModel, isUseManager, onCellClick, queryOptions, handleApproval} = props;
    const navigate = useNavigate();
    const debugPrint = false;
    const apiRef = useGridApiRef(); // Create the apiRef
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
      ManageId: false,
      BoardId: false,
      BoardOrd: false,
      BoardType: false,
      CreatedBy: false,
    });
    const matches = useMediaQuery('(max-width:800px)');

    const handleDetailClick = (params) => {
      if (dataType === "manage") return;

      if (dataType === "board" || dataType === "qna") {
        const board_id = params.row.BoardId;
        const manage_id = params.row.ManageId;

        if (isDebug() && debugPrint) logDebugInfo(params);

        if (isInvalidManageId(manageId, manage_id)) return;

        if (manageId === process.env.REACT_APP_BOARD_FAQ_MANAGE_ID) {
          if (isDebug() && debugPrint) console.log("## ControlDataGrid handleDetailClick  Not Action", new Date().toISOString(), manageId, manage_id);
          return;
        }

        navigateToDetailPage(manageId, manage_id, board_id);
      }
    };

    const logDebugInfo = (params) => {
      console.log("## ControlDataGrid handleDetailClick", new Date().toISOString(), manageId, params.row.ManageId, '-->', process.env.REACT_APP_BOARD_FAQ_MANAGE_ID, process.env.REACT_APP_BOARD_QNA_MANAGE_ID, process.env.REACT_APP_BOARD_FREE_MANAGE_ID, '-->', params.row);
    };

    const isInvalidManageId = (manageId, manage_id) => {
      if (!manageId) {
        if (isDebug() && debugPrint) console.log("## ControlDataGrid handleDetailClick  Empty", new Date().toISOString());
        return true;
      }
      if (manageId.toString() !== manageId) {
        if (isDebug() && debugPrint) console.log("## ControlDataGrid handleDetailClick Not Equels", new Date().toISOString(), manageId, manage_id);
        return true;
      }
      return false;
    };

    const navigateToDetailPage = (manageId, manage_id, board_id) => {
      if (manageId === process.env.REACT_APP_BOARD_QNA_MANAGE_ID) {
        if (isDebug() && debugPrint) console.log("## ControlDataGrid handleDetailClick  qnaview", new Date().toISOString());
        navigate(`/qnaview/${manage_id}/${board_id}`, {state: queryOptions});
      } else if (manageId === process.env.REACT_APP_BOARD_FREE_MANAGE_ID) {
        if (isDebug() && debugPrint) console.log("## ControlDataGrid handleDetailClick  boardview", new Date().toISOString());
        navigate(`/boardview/${manage_id}/${board_id}`, {state: queryOptions});
      }
    };

      
    React.useEffect(() => {
      if(dataType === undefined || dataType === null || dataType === '' || dataType === "board")
      {
        /// Columns4Board 컬럼을 숨기기
        if (isUseManager === undefined || isUseManager === null || isUseManager === false)
        {
          setColumnVisibilityModel({
            ManageId: false,
            BoardId: false,
            BoardOrd: false,
            BoardType: false,
            HasReply: false,
            CreatedBy: false,
            RowNum: !matches,
            CreatedByName: !matches,
            BoardHit: !matches,
          });
        }
        else
        {
          setColumnVisibilityModel({
            ManageId: false,
            BoardId: false,
            HasReply: false,
            CreatedBy: false,
          });
        }
      }
      else if(dataType === "qna")
      {
        /// Columns4Board 컬럼을 숨기기
        if (isUseManager === undefined || isUseManager === null || isUseManager === false)
        {
          setColumnVisibilityModel({
            ManageId: false,
            BoardId: false,
            BoardOrd: false,
            BoardType: false,
            CreatedBy: false,
            RowNum: !matches,
            CreatedByName: !matches,
            BoardHit: !matches,
          });
        }
        else
        {
          setColumnVisibilityModel({
            ManageId: false,
            BoardId: false,
            CreatedBy: false,
          });
        }
      }
      else if (dataType === "manage") {
        /// Columns4Manage 컬럼을 숨기기
        setColumnVisibilityModel({
          ConnectionId: false,
        });
      }
      else if (dataType === "user") {
        /// Columns4Member 컬럼을 숨기기
        setColumnVisibilityModel({
          CompanyId: false,
          ConnectionId: false,
          CreatedBy: false,
        });
      }

    }, [dataType, isUseManager]);

    React.useEffect(() => {
      if (isDebug() && debugPrint) console.log("## ControlDataGrid useEffect", new Date().toISOString(), manageId, dataSet);
    }, [manageId, dataSet]);


    return (
        <DataGrid
            apiRef={apiRef}
            density="standard"
            columns={boardColumns(t, handleApproval)}
            columnVisibilityModel={columnVisibilityModel}
            rows={dataSet.records}
            rowCount={dataSet.rowLength}
            getRowId={(row) =>  row.RowNum}
            loading={dataSet.isLoading}
            columnHeight={34}
            rowHeight={34}
            checkboxSelection={false}
            disableMultipleRowSelection={false}
            disableColumnMenu
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            slots={{ noRowsOverlay: CustomNoRowsOverlay }}
            sx={{ '--DataGrid-overlayHeight': '300px', minHeight: '460px' }}
            pageSizeOptions={[10, 20, 50, 100]}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            slotProps={{ pagination: { labelRowsPerPage: t('searchfield.rows_per_page') } }}
            paginationMode="server"
            sortingMode="server"
            filterMode="server"
            onCellClick={onCellClick || handleDetailClick}
        />
    );
};

        
ControlDataGrid.propTypes = {
  t: PropTypes.func.isRequired,
  dataType: PropTypes.string,
  manageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boardColumns: PropTypes.func.isRequired,
  dataSet: PropTypes.shape({
      records: PropTypes.array.isRequired,
      rowLength: PropTypes.number.isRequired,
      isLoading: PropTypes.bool.isRequired,
  }).isRequired,
  paginationModel: PropTypes.object.isRequired,
  setPaginationModel: PropTypes.func.isRequired,
  isUseManager: PropTypes.bool,
  onCellClick: PropTypes.func,
  queryOptions: PropTypes.object,
};